import { useTranslation } from 'react-i18next';

import { CustomFilterContainer, CustomFilterPopover } from 'components/data/helpers/filters.style';
import { Button, Tooltip } from 'components/ui';

import { FilterMultiSelectContainer, TableFilterMultiSelect } from './TableFilterMultiSelect';

type Props = {
  options: { value: string; label: string }[];
};

export const LockedFilterDropdown = ({ options }: Props) => {
  const { t } = useTranslation();

  return (
    <CustomFilterPopover className="ant-table-filter-dropdown" data-testid="locked-filter-dropdown">
      <CustomFilterContainer>
        <FilterMultiSelectContainer>
          <Tooltip
            title={t(
              'table.lockedFilterTooltip',
              'This filter is set by the page and cannot be changed here'
            )}
          >
            <TableFilterMultiSelect
              disabled
              options={options}
              value={options.map(({ value }) => value)}
            />
          </Tooltip>
        </FilterMultiSelectContainer>
      </CustomFilterContainer>
      <div className="ant-table-filter-dropdown-btns">
        <Button type="link" size="small" disabled>
          {t('table.reset', 'Reset')}
        </Button>
        <Button type="primary" size="small" disabled>
          {t('table.ok', 'OK')}
        </Button>
      </div>
    </CustomFilterPopover>
  );
};
